import React from 'react'

export default function SubjectVerticalBar (props) {
  return (
    <div id="verticalBar">
      <ul>
        <li>100%</li>
        <li>90%</li>
        <li>80%</li>
        <li>70%</li>
        <li>60%</li>
        <li>50%</li>
        <li>40%</li>
        <li>30%</li>
        <li>20%</li>
        <li>10%</li>
        <li>0%</li>
      </ul>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Threshold/SubjectVerticalBar.js